import { useEffect } from 'react';

import { UseFormSetValue } from 'react-hook-form';

import { PaginatedPassengerAddressListRead } from 'src/common/external/bambi-api/bambiApi';

import { TripSubscriptionFormValues } from '../FormValues';

interface useSetPickupAddressProps {
  recentAddressResponse: PaginatedPassengerAddressListRead | undefined;
  setValue: UseFormSetValue<TripSubscriptionFormValues>;
  enabled: boolean;
}

/**
 * Sets the pickup address when the recent address response is available.
 * @param recentAddressResponse - The recent address response.
 * @param setValue - The setValue function.
 * @param enabled - Whether to enable setting the pickup address for this field.
 * @returns void
 */
export default function useSetPickupAddress({
  recentAddressResponse,
  setValue,
  enabled,
}: useSetPickupAddressProps) {
  useEffect(() => {
    if (enabled && recentAddressResponse?.results.length) {
      const primaryAddress = recentAddressResponse.results.find(
        (result) => result.is_primary_address
      );

      if (primaryAddress) {
        setValue('pickup.address', {
          label: primaryAddress.address.location?.label ?? '',
          value: primaryAddress.address.location?.place_id ?? '',
        });
        setValue('pickup.address_details', primaryAddress.address_details);
        setValue('pickup.driver_notes', primaryAddress.address_notes);
      }
    }
  }, [enabled, recentAddressResponse, setValue]);
}
